import * as React from "react"
import SEO from "../components/seo/seo";
import MainTransitionContainer from "../components/transitions/main-transition-container";
import NavigationBar from "../components/navigation-bar/navigation-bar";
import Hero from "../images/home_hero.png"
import HeroMobile from "../images/home_hero_mobile.png"
import useMediaQuery from "../components/media-query/use-media-query";
import I1 from "../images/sign_up.svg"
import I2 from "../images/invest.svg"
import I3 from "../images/allocate_shares.svg"
import I4 from "../images/get_shares.svg"
import Ola from "../images/ola.png"
import Baijus from "../images/baiju.png"
import Unacademy from "../images/unacademy.png"
import Razorpay from "../images/razorpay.png"
import InputRange from "react-input-range";
import "../styles/range.css";
import {useEffect, useState} from "react";
import ConversionForm from "../components/muneem-conversion/conversion-form";
import {getAnalytics} from "firebase/analytics";
import app from "gatsby-plugin-firebase-v9.0";

const Home = () => {

    const xsDown = useMediaQuery("(max-width: 500px)");
    const [slider, setSlider] = useState(5000);

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (typeof window !== undefined)
            getAnalytics(app);
    }, [])

    return (
        <>
            <NavigationBar/>
            <MainTransitionContainer id={"home"}>
                <SEO description={"On Muneem, anyone can invest in startups. Become an investor in fast growing startups with as little as ₹500"} title={"Invest in Startups for Equity"}/>
                <section id={"home"} className={"relative container mx-auto h-screen flex items-start sm:items-center"}>
                    <div className={"space-y-4"}>
                        {xsDown &&
                            <div className={"h-24"}/>
                        }
                        <h1 className={"font-display heading-1"}>
                            Equity.<br/>
                            Simplified.
                        </h1>
                        <p className={"subtitle-1 max-w-sm"} style={{ color: "#828282" }}>
                            Access <span className={"underline font-medium"} style={{ color: "#A1C70A" }}>highly-vetted</span> investment opportunities in startups for equity.
                        </p>
                        <div className={"h-4 sm:h-12"}/>
                        <div className={"space-x-4"}>
                            <button onClick={() => { setOpen(true) }} className={"button-secondary subtitle-1"}>
                                Join Muneem
                            </button>
                            <a href={"#how-it-works"} className={"hover:underline font-display subtitle-1"}>
                                Learn more
                            </a>
                        </div>
                    </div>
                    {xsDown &&
                        <div className={"absolute bottom-0"} style={{ width: "calc(100% + 48px)", height: "58%", background: `url(${HeroMobile}) center center / cover`, left: "-24px" }}/>
                    }
                    {!xsDown &&
                        <div className={"absolute right-10 transform translate-y-4"} style={{ width: "60%", height: "60%", background: `url(${Hero}) center center / contain no-repeat` }}/>
                    }
                    <div className={`${xsDown ? "h-8" : "h-36"} absolute bottom-0`} id={"how-it-works"}/>
                </section>
                <section  className={`${xsDown ? "" : "container"} relative mx-auto flex py-16 sm:py-0`}>
                    <div className={"w-full box-border rounded-2xl bg-black px-6 py-12 sm:px-16 sm:py-16 flex flex-col items-center justify-center space-y-3"}>
                        <h2 className={"font-display text-center heading-5 sm:heading-4"} style={{ color: "#cdff03" }}>
                            How it works?
                        </h2>
                        <p className={"subtitle-2 max-w-lg text-center"} style={{ color: "#e6e6e6" }}>
                            Muneem — An <span className={"underline font-medium"}>equity crowdfunding platform</span> allowing you to own a part of the next big startup.
                        </p>
                        <div className={"h-8"}/>
                        <div className={"grid grid-cols-1 sm:grid-cols-4 gap-8"}>
                            {
                                [
                                    {icon: I1, title: "Sign Up", body: "Startups & investors would be thoroughly vetted and onboarded to our platform."},
                                    {icon: I2, title: "Invest", body: "As an investor you can fund the companies you believe in & want to see succeed in the future."},
                                    {icon: I3, title: "Allocate Shares", body: "After the crowdfunding period, The founder signs and your security certificates are issued."},
                                    {icon: I4, title: "Get Returns", body: "Investors can make money when a startup they invested in on Muneem succeeds."}
                                ].map((item) => {
                                    return (
                                        <div className={"text-white flex flex-row sm:flex-col items-start sm:items-center sm:space-y-2"}>
                                            <img alt={item.title} className={"h-10 sm:h-12"} src={item.icon}/>
                                            <div className={"ml-6 sm:ml-0"}>
                                                <p className={"sm:text-center font-display subtitle-2 font-bold"}>{item.title}</p>
                                                <p className={"sm:text-center opacity-70 body-2 pt-2"}>{item.body}</p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className={"h-24 absolute bottom-0"} id={"start-investing"}/>
                </section>
                <section className={`container mx-auto py-8 sm:py-36`}>
                    <div className={"w-full grid grid-cols-1 sm:grid-cols-2 gap-12"}>
                        <div className={"space-y-5"}>
                            <h2 className={"font-display heading-3"}>
                                Why invest in startups?
                            </h2>
                            <p className={"subtitle-1"} style={{ color: "#828282" }}>
                                <span className={"underline font-medium"} style={{ color: "#A1C70A" }}>Unicorns are startups that are valued over $1B.</span> If you invest in one at an early stage, you could earn a significant return on investment.
                                While no one can predict which companies will become unicorns, Muneem gives you access to startups who have the potential to become one.
                            </p>

                            <div className={"h-0 sm:h-12"}/>
                            <button onClick={() => { setOpen(true) }} className={"button-secondary subtitle-1"}>
                                Join Muneem
                            </button>
                        </div>
                        <div className={"rounded-lg border border-zinc-300 p-6 sm:p-10"}>
                            <div className={"grid grid-cols-1 sm:grid-cols-2 gap-8"}>
                                <div className={"space-y-2"}>
                                    <p className={"body-2 opacity-80"}>If you had invested*</p>
                                    <p className={"font-display font-bold heading-5"}>₹{Intl.NumberFormat("en-in").format(slider)}</p>
                                    <div className={"pt-5"}>
                                        <InputRange
                                            minValue={500}
                                            maxValue={100000}
                                            value={slider}
                                            step={500}
                                            formatLabel={() => ""}
                                            onChange={(value: number) => setSlider(value)}
                                        />
                                    </div>
                                </div>
                                <div>
                                    {xsDown &&
                                        <div className={"w-full border-b border-zinc-300 mb-6"}/>
                                    }
                                    <p className={"body-2 opacity-80 mb-4"}>You could have theoretically made:</p>
                                    {
                                        [
                                            {img: Ola, title: "Ola", val: 2500},
                                            {img: Baijus, title: "Byjus", val: 660},
                                            {img: Unacademy, title: "Unacademy", val: 340},
                                            {img: Razorpay, title: "Razorpay", val: 125}
                                        ].map((item) => {
                                            return (
                                                <div className={"py-3 flex items-center justify-between subtitle-2"}>
                                                    <div className={"flex items-center"}>
                                                        <img src={item.img} className={"h-6 w-6"}/>
                                                        <p className={"font-medium ml-2"}>
                                                            {item.title}
                                                        </p>
                                                    </div>
                                                    <p className={"font-display font-bold "}>
                                                        ₹{Intl.NumberFormat("en-us", {maximumFractionDigits: 1, notation: "compact", currency: "inr"}).format(slider*item.val)}
                                                    </p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*<section className={"contain"}>*/}

                {/*    © 2022 CrowdInvest*/}

                {/*    16 Berkeley Street, Mayfair, London W1J 8DZ, United Kingdom*/}

                {/*    Risk Warning - Investing in start-ups and growth focussed projects is rewarding but risky in nature and not for everyone. The risks could involve loss of investments, lack of liquidity, dilution etc. Only investors who sufficiently understand these risks and can make their own investment decisions should invest. CrowdInvest nor any of its affiliates do not and will not make any investment recommendations. The page has been approved as a financial promotion of the CrowdInvest platform by Crowd Investments Limited.*/}

                {/*    It does not promote any individual investment opportunity; the information shared on investment opportunities is to showcase the wide range of investments available through CrowdInvest. Any investment should be made on the basis of the details provided by each individual project. These details are provided to registered users only. CrowdInvest is not responsible for this information or for any recommendations made by the entrepreneurs. For more information regarding the terms of service and risks involved, please read Terms of service & Risk Warning.*/}
                {/*</section>*/}
            </MainTransitionContainer>
            <ConversionForm open={open} onClose={() => {setOpen(false)}}/>
        </>
    )

}

export default Home
